export default "<p>ventas-validator works!</p>\n"